import question from './bankQuestion'
import questionDetail from './bankQuestionDetail'

import task from './task'
import taskDetail from './taskDetail'
import taskLook from './taskLook'


export {
  question as ReviewQuestion,
  questionDetail as ReviewQuestionDetail,

  task as ReviewTask,
  taskDetail as ReviewTaskDetail,
  taskLook as ReviewTaskLook,
}
